import actionTypes from './actionTypes'

const sessionActions = {
	hideStudentNamesUpdate(hideStudentNames) {
		return {
			type: actionTypes.SESSION_SETTINGS_HIDE_STUDENT_NAMES_UPDATE,
			shouldHideStudentNames: hideStudentNames,
		}
	},
	streamModeUpdate(streamMode) {
		return {
			type: actionTypes.SESSION_SETTINGS_STREAM_MODE_UPDATE,
			streamMode,
		}
	},
	teacherInitializeOeq(questionData, session, slide, slide_uid) {
		return {
			type: actionTypes.SESSION_TEACHER_OEQ_INITIALIZE,
			questionData,
			session,
			slide,
			slide_uid,
		}
	},
	oeqStudentDataFetched(answers, participation, slide_uid) {
		return {
			type: actionTypes.SESSION_TEACHER_OEQ_STUDENT_DATA_FETCHED,
			answers,
			participation,
			slide_uid,
		}
	},
}

export default sessionActions
